
import { useEffect, useRef } from 'react'

export function getNumberedChoiceShortcutIndex(
  event: KeyboardEvent,
  choiceCount: number,
) {
  if (
    event.altKey ||
    event.ctrlKey ||
    event.metaKey ||
    event.repeat ||
    event.shiftKey ||
    !/^[1-9]$/.test(event.key)
  ) {
    return null
  }

  const target = event.target
  if (
    target instanceof HTMLElement &&
    (target.isContentEditable || target.closest('input, textarea, select, [contenteditable="true"]'))
  ) {
    return null
  }

  const choiceIndex = Number(event.key) - 1
  return choiceIndex >= 0 && choiceIndex < choiceCount ? choiceIndex : null
}

function shouldIgnoreContinueShortcut(event: KeyboardEvent) {
  if (
    event.altKey ||
    event.ctrlKey ||
    event.defaultPrevented ||
    event.metaKey ||
    event.repeat ||
    event.shiftKey ||
    event.key !== 'Enter'
  ) {
    return true
  }

  const target = event.target
  return (
    target instanceof HTMLElement &&
    (target.isContentEditable ||
      Boolean(target.closest('input, textarea, select, button, a, [role="button"], [contenteditable="true"]')))
  )
}

export function useLegacyEnterContinue(onNext: () => void, enabled = true) {
  const onNextRef = useRef(onNext)

  useEffect(() => {
    onNextRef.current = onNext
  }, [onNext])

  useEffect(() => {
    if (!enabled) {
      return undefined
    }

    const handleKeyDown = (event: KeyboardEvent) => {
      if (shouldIgnoreContinueShortcut(event)) {
        return
      }

      event.preventDefault()
      onNextRef.current()
    }

    window.addEventListener('keydown', handleKeyDown)

    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [enabled])
}
